import withSharedStyles from "../../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, radius, fontSize } = theme.tokens;

  return {
    // GEmpty
    empty: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      gap: 8,
      padding: "48px 16px"
    },
    emptyDisc: {
      width: 72,
      height: 72,
      borderRadius: radius.pill,
      backgroundColor: color.surface,
      color: color.ink,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: 8,
      "& svg": { fontSize: theme.tokens.iconSize.xxl, width: 32, height: 32 }
    },
    emptyTitle: {
      margin: 0,
      fontSize: fontSize.h3,
      fontWeight: 800,
      color: color.ink
    },
    emptyText: {
      margin: 0,
      fontSize: fontSize.body,
      color: color.muted,
      maxWidth: 360
    },
    emptyAction: {
      marginTop: 12
    },

    // GNotice
    notice: {
      display: "flex",
      alignItems: "flex-start",
      gap: 12,
      padding: "14px 16px",
      borderRadius: radius.tile,
      fontSize: fontSize.ui,
      lineHeight: 1.45,
      color: color.ink
    },
    info: {
      backgroundColor: color.brandTint,
      "& $noticeIcon": { color: color.brandText }
    },
    error: {
      backgroundColor: color.dangerTint,
      "& $noticeIcon": { color: color.danger }
    },
    success: {
      backgroundColor: color.successTint,
      "& $noticeIcon": { color: color.success }
    },
    noticeIcon: {
      display: "flex",
      flex: "none",
      "& svg": { fontSize: theme.tokens.iconSize.md }
    },
    noticeBody: {
      display: "flex",
      flexDirection: "column",
      gap: 2,
      flex: 1,
      minWidth: 0
    },
    noticeTitle: {
      fontWeight: 700
    },

    // GDialog
    paper: {
      width: "100%",
      maxWidth: 480,
      margin: 16,
      padding: 24,
      borderRadius: radius.dialog,
      boxSizing: "border-box"
    },
    sheetContainer: {
      alignItems: "flex-end"
    },
    sheet: {
      margin: 0,
      maxWidth: "100%",
      borderRadius: `${radius.dialog}px ${radius.dialog}px 0 0`,
      paddingBottom: "calc(24px + env(safe-area-inset-bottom))"
    },
    dialogTitle: {
      margin: "0 0 8px",
      fontSize: fontSize.h3,
      fontWeight: 800,
      color: color.ink
    },
    dialogBody: {
      fontSize: fontSize.body,
      color: color.text2,
      lineHeight: 1.5
    },
    dialogActions: {
      display: "flex",
      justifyContent: "flex-end",
      flexWrap: "wrap",
      gap: 8,
      marginTop: 24,
      [theme.media.phone]: {
        flexDirection: "column-reverse",
        "& > *": { width: "100%" }
      }
    }
  };
});

export default withCustomStyles;
